module.exports = __webpack_public_path__ + "media/Franchise_Promo_Ad(1080p).9bb1727.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Franchise_Promo_Ad(1080p).mp4
// module id = 1650
// module chunks = 1